import React, {useEffect, useState} from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import "../css/ContactNiveles.css";
import "../css/Escribenos.css";
import Aos from 'aos';
import "aos/dist/aos.css";
import { useForm } from 'react-hook-form';
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { endpointDeFormulario } from "../config/formularios";

export default function ContactNiveles(props) {
  const {register, errors, handleSubmit, reset} = useForm();
  const [enviando, setEnviando] = useState(false);
  const [aviso, setAviso] = useState(null);
  const dest = props.emailSend;

  const onSubmit = async data => {
    // Honeypot: si viene completo es un bot, cortamos sin avisar nada.
    if (data._honey) return;

    setEnviando(true);
    setAviso(null);

    try {
      const res = await axios.post(
        endpointDeFormulario(dest),
        {
          _subject: `Consulta desde la web (${props.nivel}) - ${data.nombre}`,
          _template: "table",
          // FormSubmit muestra su propio reCAPTCHA salvo que se desactive, y esa
          // pantalla es incompatible con el envío por AJAX.
          _captcha: "false",
          _replyto: data.correo,
          Nombre: data.nombre,
          Teléfono: data.telefono,
          Correo: data.correo,
          Mensaje: data.mensaje,
        },
        { headers: { "Content-Type": "application/json", Accept: "application/json" } }
      );

      const exito = res.data && res.data.success !== undefined
        ? res.data.success === true || res.data.success === "true"
        : res.status >= 200 && res.status < 300;

      // Mientras la casilla no esté confirmada en FormSubmit, la respuesta llega
      // pidiendo activación y el mensaje nunca se entrega. Lo avisamos en vez de
      // dar un "enviado" falso.
      const pendienteDeActivacion = /confirm|activat/i.test(
        String((res.data && res.data.message) || "")
      );

      if (!exito || pendienteDeActivacion) {
        throw new Error(
          pendienteDeActivacion
            ? `Falta activar la casilla ${dest} en FormSubmit`
            : "Respuesta sin confirmación"
        );
      }

      setAviso({
        tipo: "ok",
        texto: "¡Gracias! Recibimos tu mensaje y te vamos a responder a la brevedad.",
      });
      reset();
    } catch (error) {
      // El motivo real queda en la consola (útil al configurar); la familia solo
      // ve un mensaje claro con la alternativa para contactarse.
      console.error("Formulario de contacto:", error);
      setAviso({
        tipo: "error",
        texto: `No pudimos enviar tu mensaje. Probá de nuevo o escribinos a ${dest}.`,
      });
    } finally {
      setEnviando(false);
    }
  };

  useEffect(() => {
    Aos.init({});
  }, [])

  return (
    <>
      <Container className="contenedor-contact-niveles"  data-aos="fade-up">
        <h2 className="envianos-un-mensaje" id={props.color}>Envianos <br></br> un mensaje</h2>
        <hr className="envianos-un-mensaje-hr mb-5"id={props.color} ></hr>
        <p id={props.color}>Para: {props.emailSend}</p>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* Trampa anti-spam: invisible para las personas, la completan los bots.
              FormSubmit descarta en silencio cualquier envío con _honey cargado. */}
          <input
            type="text"
            name="_honey"
            className="campo-trampa"
            tabIndex="-1"
            autoComplete="off"
            ref={register}
          />
          <Row>
            <Col md={6} className="inputs">
              <Form.Control
                className="mb-3"
                placeholder="Nombre"
                name="nombre"
                autoComplete="name"
                ref={
                  register({
                    required: {value: true, message: 'Este campo es obligatorio'}
                  })
                }
              />
              <span className="text-danger text-small d-block mb-2">
                  {errors?.nombre?.message}
              </span>
              <Form.Control
                placeholder="Telefono"
                className="mb-3"
                name="telefono"
                type="tel"
                autoComplete="tel"
                ref={
                  register({
                    required: {value: true, message: 'Este campo es obligatorio'}
                  })
                }
              />
              <span className="text-danger text-small d-block mb-2">
                  {errors?.telefono?.message}
              </span>
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Control
                  type="email"
                  placeholder="tucorreo@ejemplo.com"
                  className="mb-3"
                  name="correo"
                  autoComplete="email"
                  ref={
                    register({
                      required: {value: true, message: 'Este campo es obligatorio'},
                      pattern: {value: /^\S+@\S+\.\S+$/, message: 'Ingresá un correo válido'}
                    })
                  }
                />
                <span className="text-danger text-small d-block mb-2">
                    {errors?.correo?.message}
                </span>
              </Form.Group>
            </Col>
            <Col md={6} className="mensaje-form">
              <Form.Group controlId="exampleForm.ControlTextarea1" >
                <Form.Control
                    as="textarea"
                    className="area-mensaje mb-4 "
                    placeholder="Tu mensaje"
                    name="mensaje"
                    ref={
                      register({
                        required: {value: true, message: 'Este campo es obligatorio'}
                      })
                    }
                />
                <span className="text-danger text-small d-block mb-2">
                    {errors?.mensaje?.message}
                </span>
              </Form.Group>
            </Col>
          </Row>
          <button type="submit" className="bt-1 bt-ajust" disabled={enviando} data-aos="fade-up">
            {enviando ? <Spinner animation="border" variant="dark" /> : "Enviar"}
          </button>
          {aviso && (
            <p className={`aviso-formulario aviso-${aviso.tipo}`} role="status">
              {aviso.texto}
            </p>
          )}
        </Form>
     </Container>
    </>
  );
}
